import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { ReportingPayload } from "../interfaces/ReportingPayload";
import { DownloadPdfRequest } from "../../reports/useDownloadPdf";

interface Props {
  onAuthError?: () => void;
}

export default class UTP2FilesApis extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.UTP2_API}/api/Files/`;

  getMediaByDataPointIdAndFilepath = (dataPointId: number, filepath: string): Promise<any> => {
    const apiAddress = `${UTP2FilesApis.BASE_URL}media/${dataPointId}?filepath=${encodeURIComponent(filepath)}`;

    return this.apiResponseHandler.get(apiAddress).then((data) => {
      return data;
    });
  };

  getWavByDataPointIdAndFilepath = (dataPointId: number, filepath: string): Promise<any> => {
    const apiAddress = `${UTP2FilesApis.BASE_URL}wav/${dataPointId}?filepath=${encodeURIComponent(filepath)}`;

    return this.apiResponseHandler.get(apiAddress).then((data) => {
      return data;
    });
  };

  async uploadImageFile(
    file: File,
    assetId: number,
    captureId: number,
    datapointId: number,
    surveyAssetName: string,
    panelAssetId?: number,
  ) {
    const formData = new FormData();
    formData.append("file", file);

    const apiAddress = `${UTP2FilesApis.BASE_URL}image/assets/${assetId}/captures/${captureId}/dataPoints/${datapointId}/surveyAssetNames/${surveyAssetName}/panelAssets/${panelAssetId ? panelAssetId : ""}`;
    return await this.apiResponseHandler.postFile(apiAddress, formData);
  }

  postCreateReport = async (reportingPayload: ReportingPayload): Promise<Response> => {
    const apiAddress = `${UTP2FilesApis.BASE_URL}reports/word`;

    return this.apiResponseHandler.post(apiAddress, JSON.stringify(reportingPayload));
  };

  generateAppendix = (reportingPayload: ReportingPayload): Promise<number> => {
    const apiAddress = `${UTP2FilesApis.BASE_URL}CreateAppendixDocument`;

    return this.apiResponseHandler.post(apiAddress, JSON.stringify(reportingPayload), false);
  };

  getPdf = async (request: DownloadPdfRequest): Promise<string> => {
    const apiAddress = `${UTP2FilesApis.BASE_URL}reports/pdf/report/${request.generatedReportId}/customer/${request.customerId}/company/${request.companyId}/site/${request.siteId}`;
    return await this.apiResponseHandler.get(apiAddress);
  };

  convertToPdf = async (reportDocumentId: number): Promise<Response> => {
    const apiAddress = `${UTP2FilesApis.BASE_URL}ConvertToPdf/${reportDocumentId}`;

    return this.apiResponseHandler.post(apiAddress);
  };
}
